




import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class IframePageRenderer extends Vue {
  @Prop({ required: true }) page!: string;
  @Prop({ required: false, default: "" }) title!: string;

  public iframeKey = 0;
  public srcdoc = "";

  @Watch("page", { immediate: true })
  onPageChanged(): void {
    this.generateSrcDoc();
  }

  private generateSrcDoc(): void {
    if (!this.page || typeof this.page !== "string") return;

    this.iframeKey++;
    this.srcdoc = `
      <!DOCTYPE html>
      <html lang="de">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <link rel="stylesheet" href="https://wiki.drive.buzz/dist/styles.css?version=v24.05.2" />

          <style>
            html, body {
              margin: 0;
              padding: 1rem;
              box-sizing: border-box;
              width: 100%;
              min-height: 100%;
              overflow-y: auto;
              overflow-x: hidden;
              font-family: sans-serif;
              background: white;
            }

            body {
              padding-top: 0;
              padding-bottom: 0;
            }

            body::-webkit-scrollbar {
              display: none;
            }

            html {
              height: 100%;
            }

            body {
              height: auto;
            }

            *, *::before, *::after {
              box-sizing: inherit;
            }


            h1, h2, h3, h4, h5 {
              font-weight: bold;
              line-height: 1.4;
              margin-top: 20px;
              margin-bottom: 10px;
              color: #2c3e50;
            }

            h1 {
              font-size: 32px;
            }

            h2 {
              font-size: 28px;
            }

            h3 {
              font-size: 24px;
            }

            h4 {
              font-size: 20px;
            }

            h5 {
              font-size: 18px;
            }

            img {
              max-width: 100%;
              height: auto;
              display: block;
              margin: 1rem auto;
            }

            p {
              margin-bottom: 1rem;
            }
 
            ul, ol {
              padding-left: 1.5rem;
              margin-bottom: 1rem;
            }

            .callout, .warning {
              border-left: 4px solid #ffc107;
              background-color: #fff8e1;
              padding: 1rem;
              margin: 1rem 0;
              border-radius: 4px;
            }

            th {
              font-weight: bold;
            }
        </style>
        </head>
        <body>
          <div>
            ${this.title ? `<h1>${this.title}</h1>` : ""}
            ${this.page}
          </div>
        </body>
      </html>
    `;
  }

  private onIframeLoaded(): void {
    this.$emit("iframe-mounted");
  }
}
